import React from "react";
import { createStackNavigator } from "@react-navigation/stack";
import EmulateUserPage from "../screens/EmulateUser/EmulateUserPage";

const Stack = createStackNavigator();

const EmulateUserStackNavigator = () => {
  return (
    <Stack.Navigator
      screenOptions={{
        headerShown: false,
      }}
    >
      <Stack.Screen name="EmulateUsers" component={EmulateUserPage} />
    </Stack.Navigator>
  );
};

export default EmulateUserStackNavigator;
